import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Button, Grid, TextField, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Divider, IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import WorkspaceValidator from '../../components/workspace-validator';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";

class AdminTrialCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            item: {
                companyName: '',
                cnpj: '',
                responsibleName: '',
                responsiblePhone: '',
                email: '',
                workspace: '',
                trialDurationDays: 14,
                companySizeId: '',
            },
            workspaceValid: false,
            confirmDialogOpen: false,
            paymentGateways: [],
            selectedPaymentGatewayId: null,
            companySizes: [],
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
    }

    componentDidMount() {
        adminBillingService.getPaymentGateways()
            .then(r => {
                const gateways = r.data.success ? (r.data.data || []) : [];
                this.setState({ paymentGateways: gateways,
                    selectedPaymentGatewayId: gateways.length > 0 ? (gateways.find(g => g.isdefault || g.isDefault)?.id || gateways[0].id) : null });
            })
            .catch(() => {});

        adminBillingService.getCompanySizes()
            .then(r => {
                const sizes = r.data.success ? (r.data.data || []) : [];
                this.setState({ companySizes: sizes });
            })
            .catch(() => {});
    }

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(prevState => ({
            item: { ...prevState.item, [name]: value }
        }));
    }

    handleWorkspaceChange = (value) => {
        this.setState(prevState => ({
            item: { ...prevState.item, workspace: value }
        }));
    }

    handleWorkspaceValidation = (isValid) => {
        this.setState({ workspaceValid: isValid });
    }

    handleSubmit(e) {
        e.preventDefault();
        const intl = this.props.intl;
        const { item, workspaceValid } = this.state;

        if (!item.companyName || !item.email || !item.workspace || !item.responsibleName) {
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "admin.trial.fill.required" })
            });
            return;
        }

        if (!workspaceValid) {
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "admin.trial.workspace.invalid" })
            });
            return;
        }

        this.setState({ confirmDialogOpen: true });
    }

    handleConfirmCreate = () => {
        const intl = this.props.intl;
        const { item } = this.state;

        this.setState({ confirmDialogOpen: false, loading: true });

        const payload = {
            companyName: item.companyName,
            responsibleName: item.responsibleName,
            responsibleEmail: item.email,
            responsiblePhone: item.responsiblePhone,
            workspace: item.workspace,
            cnpj: item.cnpj,
            trialDurationDays: item.trialDurationDays,
            contractType: 'trial',
            paymentGatewayId: this.state.selectedPaymentGatewayId,
            companySizeId: item.companySizeId ? parseInt(item.companySizeId) : null,
        };

        adminBillingService.createContract(payload)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({ id: "add.success" }),
                    });
                    const responseData = result.data.data;
                    const queueId = responseData?.provisioningqueueid ?? responseData?.provisioningQueueId;
                    if (queueId) {
                        this.props.addCurrentProvisioning({ id: queueId, workspace: item.workspace });
                        setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning-detail`), 1500);
                    } else {
                        setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning`), 1500);
                    }
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;
        const { item } = this.state;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='md'>
                        <CssBaseline />
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <SectionCard
                                    context="assignment"
                                    title={intl.formatMessage({ id: "admin.trials.create" })}
                                    subtitle="Preencha os dados do novo trial para disparar o provisionamento"
                                >
                                    <form onSubmit={this.handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={intl.formatMessage({ id: "admin.trial.duration" })}
                                                        name="trialDurationDays"
                                                        select
                                                        value={item.trialDurationDays}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                        required
                                                    >
                                                        <MenuItem value={7}>7 {intl.formatMessage({ id: "admin.trial.days" })}</MenuItem>
                                                        <MenuItem value={14}>14 {intl.formatMessage({ id: "admin.trial.days" })}</MenuItem>
                                                        <MenuItem value={30}>30 {intl.formatMessage({ id: "admin.trial.days" })}</MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Metodo de Pagamento"
                                                        select
                                                        value={this.state.selectedPaymentGatewayId || ''}
                                                        onChange={(e) => this.setState({ selectedPaymentGatewayId: e.target.value ? parseInt(e.target.value) : null })}
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                    >
                                                        {this.state.paymentGateways.map(gw => (
                                                            <MenuItem key={gw.id} value={gw.id}>
                                                                {gw.name ?? gw.gatewaytype ?? gw.gatewayType} {(gw.isdefault || gw.isDefault) ? '(Padrao)' : ''}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={intl.formatMessage({ id: "admin.trial.company.name" })}
                                                        name="companyName"
                                                        value={item.companyName}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="CNPJ"
                                                        name="cnpj"
                                                        value={item.cnpj}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={intl.formatMessage({ id: "admin.trial.responsible.name" })}
                                                        name="responsibleName"
                                                        value={item.responsibleName}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="E-mail Responsavel"
                                                        name="email"
                                                        type="email"
                                                        value={item.email}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Telefone do Responsavel"
                                                        name="responsiblePhone"
                                                        value={item.responsiblePhone}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={intl.formatMessage({ id: "admin.hirer.company_size" })}
                                                        name="companySizeId"
                                                        select
                                                        SelectProps={{ native: true }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={item.companySizeId}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                    >
                                                        <option value="">{intl.formatMessage({ id: "admin.hirer.company_size.placeholder" })}</option>
                                                        {this.state.companySizes.map(cs => (
                                                            <option key={cs.id} value={cs.id}>{cs.name}</option>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <WorkspaceValidator
                                                        label={intl.formatMessage({ id: "admin.trial.workspace" })}
                                                        value={item.workspace}
                                                        onChange={this.handleWorkspaceChange}
                                                        onValidation={this.handleWorkspaceValidation}
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                                    <Button variant="contained" color="default" component={Link} to={`/${this.props.match.params.lang}/admin-trials`}>
                                                        {intl.formatMessage({ id: "cancel" })}
                                                    </Button>
                                                    <Button type="submit" variant="contained" color="primary">
                                                        {intl.formatMessage({ id: "save" })}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                    </form>
                                </SectionCard>
                            </Grid>
                        </Grid>

                        {/* Confirm Dialog */}
                        <Dialog open={this.state.confirmDialogOpen} onClose={() => this.setState({ confirmDialogOpen: false })} maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{intl.formatMessage({ id: "admin.trial.create.confirm.title" })}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ confirmDialogOpen: false })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.company.name" })}</Typography>
                                        <Typography variant="body1"><strong>{item.companyName}</strong></Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">Workspace</Typography>
                                        <Typography variant="body1"><strong>{item.workspace}</strong></Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.responsible.name" })}</Typography>
                                        <Typography variant="body1">{item.responsibleName}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "email" })}</Typography>
                                        <Typography variant="body1">{item.email}</Typography>
                                    </Grid>
                                    {item.cnpj && (
                                        <Grid item xs={6}>
                                            <Typography variant="body2" color="textSecondary">CNPJ</Typography>
                                            <Typography variant="body1">{item.cnpj}</Typography>
                                        </Grid>
                                    )}
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.duration" })}</Typography>
                                        <Typography variant="body1">{item.trialDurationDays} {intl.formatMessage({ id: "admin.trial.days" })}</Typography>
                                    </Grid>
                                </Grid>
                                <Divider style={{ margin: '16px 0 8px' }} />
                                <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                                    {intl.formatMessage({ id: "admin.trial.create.confirm.message" })}
                                </Typography>
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ confirmDialogOpen: false })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" color="primary" onClick={this.handleConfirmCreate} style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                    {intl.formatMessage({ id: "confirm" })}
                                </Button>
                            </div>
                        </Dialog>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminTrialCreate.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminTrialCreate)));
